<template>
  <AttrGroup title="特性">
    <AttrSelect
      label="容器类型"
      class="w-full"
      :value="shape.attrs.slotType"
      :options="slotTypeList"
      :disabled="!!attrDisabled || !!isSlotFollowing"
      @change="(val:SlotType)=>onSelectChange(val)
         "
    />
    <!-- <SlotBorder
      v-if="shape.attrs.slotType === 'widget'"
      class="mt-2.5"
      :shape="shape"
    ></SlotBorder> -->
    <SlotList
      :shape="props.shape"
      :slot-type="slotType"
      :following-slot="followingSlot"
      :is-support-slot-following="isSupportSlotFollowing"
      :is-slot-following="isSlotFollowing"
    />
  </AttrGroup>
</template>

<script lang="ts" setup>
import { Shape, ShapeType } from '@/services/shape';
import { Attributes } from '@/services/shape/attributes';
import { useEditorStore } from '@/store/use-editor-store';
import { PropType, computed, ref } from 'vue';
import { Modal } from 'ant-design-vue';
import { canUse } from '@/utils/can-use.utils';
import { useSlotFollow } from '@/hooks/use-slot-follow';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});
type SlotType = Attributes['slotType'];
const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);
const {
  judgeIfFollowingSlot,
  findFollowingSlot,
  judgeIsSupportSlotFollowing,
  followParentAttrs
} = useSlotFollow();
const slotTypeList = computed(() => {
  const res = [{ label: '数据项', value: 'widget' }];
  // 取消工具中容器中的“时间、刻度盘、字体样式”：BPGJ-1212
  // 判断是否支持双时区，如果支持则增加
  if (canUse('dualtime').valid) {
    res.push({ label: '双时区', value: 'dualTime' });
  }
  return res;
});
const onSelectChange = (slotType: SlotType) => {
  const otherSlots =
    editorStore.theme?.children
      .filter(
        (item) => item.type == ShapeType.Slot && item.id !== props.shape.id
      )
      .map((item) => Shape.getShape(item.id)) ?? [];
  if (
    !['widget', 'dualTime'].includes(slotType) &&
    otherSlots.some((item) => item?.attrs.slotType == slotType)
  ) {
    Modal.warning({
      title: '提示',
      content: '此选项只能选择一次,已在其他容器中被选择。',
      okText: '知道了'
    });
  } else {
    setAttrs({
      slotType: slotType
    });
    if (props.shape.attrs.followingGroupName !== undefined) {
      followParentAttrs(props.shape, 'slotType', slotType);
    }
  }
};

const slotType = ref();

const setAttrs = (data: Partial<Omit<Attributes, 'resources'>>) => {
  props.shape?.setAttrs(data);
};

const followingSlotId = computed(
  () => props.shape.attrs.slotFollowingId ?? undefined
);

const followingSlot = computed(() => findFollowingSlot(followingSlotId.value));

const isSupportSlotFollowing = computed(() => judgeIsSupportSlotFollowing());

const isSlotFollowing = computed(() =>
  judgeIfFollowingSlot(followingSlotId.value)
);
</script>
